
import icon1 from '../images/icon/quote-2.png'
import avt1 from '../images/layouts/avt-08.png'
import avt2 from '../images/layouts/avt-09.png'
import avt3 from '../images/layouts/avt-10.png'


const dataTestimonials2 = [

    {
        id: 1,
        icon: icon1,
        text: '“ Praesent felis justo, porta id tortor vel, auctor aliquet ligula. Nam blandit mi vel pulvinar convallis. Nam at ligula a erat laoreet tincidunt ac ut lorem. “',
        avt: avt1,
        name: 'Annette Black',
        position: 'Founder & CEO'
    },
    {
        id: 2,
        icon: icon1,
        text: '“ Curabitur eu est feugiat quam feugiat tristique non vel erat. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nunc nec suscipit fringilla, augue ligula eleifend velit. “',
        avt: avt2,
        name: 'Leslie Alexander',
        position: 'CEO & Founder at ThemeMu'
    },
    {
        id: 3,
        icon: icon1,
        text: '“ Etiam dignissim ex vitae tortor viverra, varius tincidunt sem vestibulum. Donec ex ante, sollicitudin sit amet posuere venenatis, consectetur facilisis nisi malesuada nisi nec ex. “',
        avt: avt3,
        name: 'Esther Howard',
        position: 'Chief Product Officer'
    },

]

export default dataTestimonials2;